import {
  ExtraDrawsAddOnResult,
  MiniGameAddOnResult,
  MultiplierAddOnResult,
} from '@Config/draw-results-types'
import { Background } from './mechanics/base/background'
import { KenoNumber } from './mechanics/base/number'
import { NumberSelector } from './mechanics/base/number-selector'
import { PreBakedAnimation } from './mechanics/base/transition-animation'
import { MultiplierAnimation } from './mechanics/add-on-multiplier/multiplier-animation'
import { GAME_SPEED } from '@AppState/app-settings'
import { Foreground } from './mechanics/base/foreground'
import { KenoCumulativeResult } from '@interaction-gaming/game-data-service-browser-client'
import { AudioKeyTemplate } from './constants'

export enum SCENE_KEYS {
  DRAW_ANIMATION = 'DRAW_ANIMATION',
  LOADING = 'LOADING',
}

export enum ANIMATION_IDENTIFIERS {
  DEFAULT = 'DEFAULT',
  CYBER_SNAKES = 'CYBER_SNAKES',
  KENO_SNAKES = 'KENO_SNAKES',
  LIGHT_THREE = 'LIGHT_THREE',
  NEON_LIGHTS = 'NEON_LIGHTS',
  PLINKO = 'PLINKO',
  RED_BALL = 'RED_BALL',
  SPACE_INVADERS = 'SPACE_INVADERS',
}

export type ExtraDrawAnimationConfig = {
  assetPreloader: (scene: Phaser.Scene) => void
  transition: typeof PreBakedAnimation
  numberSelector: typeof NumberSelector
  kenoNumber: typeof KenoNumber
  textureLoader: (scene: Phaser.Scene) => void
}

export type MultiplierAnimationConfig = {
  assetPreloader: (scene: Phaser.Scene) => void
  revealAnimation: typeof MultiplierAnimation
}

export type DrawAnimationConfig = {
  mechanicConfig: DrawAnimationMechanicConfig
  results: DrawAnimationResult
  settings: DrawAnimationSettings
}

export type DrawAnimationTicketInfo = {
  baseSelectedNumbers: number[]
  miniGameSelectedNumbers: number[]
  multiplierAddOn: string | undefined
}

export type DrawAnimationMechanicConfig = {
  assetPreloader: (scene: Phaser.Scene) => void
  appSettings: AppSettings
  background: typeof Background
  extraDrawAnimationConfig: ExtraDrawAnimationConfig | null
  foreground?: typeof Foreground | null
  kenoNumber: typeof KenoNumber
  multiplierAnimationConfig: MultiplierAnimationConfig | null
  numberSelector: typeof NumberSelector
  textureLoader: (scene: Phaser.Scene) => void,
  audioKeys?: AudioKeyTemplate
}

export type AppSettings = {
  backgroundBaseColor: string
  backgroundGlowColor: string
  backgroundUrl: string
}

export type DrawAnimationResult = {
  drawNumber: number
  extraDrawAddOnResult: ExtraDrawsAddOnResult | undefined
  miniGameAddOnResult: MiniGameAddOnResult | undefined
  multiplierAddOnResult: MultiplierAddOnResult | undefined
  ticketInfo: DrawAnimationTicketInfo
  winningNumbers: KenoCumulativeResult[]
}

export type DrawAnimationSettings = {
  gameMode: GAME_MODE
  gameSpeed: GAME_SPEED
  startPaused: boolean
}

export enum GAME_MODE {
  VIEW = 'VIEW',
  TICKET = 'TICKET',
}
